(function () {
  'use strict';

  function safe(fn) {
    try { fn(); } catch (err) { /* one feature failing must never break the rest */ }
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveal on scroll (with safety net: content always ends up visible) --- */
  var revealEls = document.querySelectorAll('.st-reveal');
  safe(function () {
    if ('IntersectionObserver' in window && revealEls.length) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  });
  setTimeout(function () {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }, 3000);

  /* --- Signature thread: SVG stroke draws in as each segment scrolls through view --- */
  var threadTicking = false;
  safe(function () {
    var threadSegments = Array.prototype.slice.call(document.querySelectorAll('.stayly-thread-path'));
    if (!threadSegments.length) return;
    var threadState = [];

    function measureThread() {
      threadState = threadSegments.map(function (path) {
        var length = path.getTotalLength();
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = reduceMotion ? 0 : length;
        return { path: path, length: length, section: path.closest('.stayly-thread-wrap').parentElement };
      });
    }

    function updateThread() {
      var vh = window.innerHeight;
      threadState.forEach(function (item) {
        var rect = item.section.getBoundingClientRect();
        var total = rect.height + vh;
        var scrolled = vh - rect.top;
        var progress = scrolled / total;
        progress = Math.max(0, Math.min(1, progress));
        item.path.style.strokeDashoffset = item.length * (1 - progress);
      });
    }

    measureThread();
    updateThread();
    window.addEventListener('resize', function () { safe(function () { measureThread(); updateThread(); }); });
    window.addEventListener('scroll', function () {
      if (threadTicking) return;
      threadTicking = true;
      requestAnimationFrame(function () { safe(updateThread); threadTicking = false; });
    }, { passive: true });
  });

  /* --- Bundle picker: sets the hidden quantity input + updates displayed price --- */
  safe(function () {
    document.querySelectorAll('[data-stayly-bundle]').forEach(function (picker) {
      var scope = picker.closest('.stayly-buy-box') || picker.parentElement || document;
      var qtyInput = scope.querySelector('[data-stayly-bundle-qty]') || scope.querySelector('input[name="quantity"]');
      var radios = picker.querySelectorAll('input[type="radio"]');

      function applySelection(radio) {
        if (qtyInput) {
          qtyInput.value = radio.value;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var price = radio.getAttribute('data-price');
        if (price) {
          scope.querySelectorAll('[data-stayly-bundle-cta-price]').forEach(function (el) {
            el.textContent = price;
          });
        }
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) applySelection(radio);
        });
      });

      var checked = picker.querySelector('input[type="radio"]:checked');
      if (checked) applySelection(checked);
    });
  });

  /* --- Real add-to-cart: fetch to /cart/add.js, then go to cart --- */
  safe(function () {
    document.querySelectorAll('[data-stayly-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"]');
        var errorEl = form.querySelector('[data-stayly-add-error]');
        if (errorEl) errorEl.hidden = true;
        if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('[name="id"]').value,
            quantity: parseInt(form.querySelector('[name="quantity"]').value || '1', 10),
          }),
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data && result.data.description ? result.data.description : 'Erreur panier');
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          })
          .catch(function () {
            if (submitBtn) submitBtn.removeAttribute('disabled');
            if (errorEl) errorEl.hidden = false;
          });
      });
    });
  });

  /* --- Sticky mobile add-to-cart bar --- */
  safe(function () {
    var stickyCart = document.querySelector('.stayly-sticky-cart');
    var buyBoxAnchor = document.querySelector('[data-stayly-buybox-anchor]');
    if (!stickyCart || !buyBoxAnchor || !('IntersectionObserver' in window)) return;
    var cartObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyCart.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    cartObserver.observe(buyBoxAnchor);
  });

  /* --- Gallery thumbnails --- */
  safe(function () {
    var mainImage = document.querySelector('[data-stayly-gallery-main]');
    document.querySelectorAll('[data-stayly-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('[data-stayly-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage) {
          var url = thumb.getAttribute('data-stayly-gallery-thumb');
          // The main image ships with a `srcset`, which the browser uses in
          // preference to `src`. Updating only `src` would leave the displayed
          // image unchanged, so point `srcset` at the chosen image too.
          mainImage.srcset = url;
          mainImage.src = url;
          var thumbImg = thumb.querySelector('img');
          if (thumbImg) mainImage.alt = thumbImg.alt;
        }
      });
    });
  });
})();
